var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "content-loader",
    {
      attrs: {
        height: 400,
        width: 390,
        speed: 0.5,
        "primary-color": "#f3f3f3",
        "secondary-color": "#ecebeb"
      }
    },
    [
      _c("rect", {
        attrs: {
          x: "40",
          y: "20",
          rx: "0",
          ry: "0",
          width: "310",
          height: "140"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "40",
          y: "200",
          rx: "0",
          ry: "0",
          width: "310",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "40",
          y: "240",
          rx: "0",
          ry: "0",
          width: "310",
          height: "20"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "40",
          y: "280",
          rx: "0",
          ry: "0",
          width: "310",
          height: "20"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }